import { render, staticRenderFns } from "./storeSelectSetting.vue?vue&type=template&id=5d23d350&scoped=true&"
import script from "./storeSelectSetting.vue?vue&type=script&lang=js&"
export * from "./storeSelectSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23d350",
  null
  
)

export default component.exports